module.exports = __webpack_public_path__ + "img/lottery_redpack.8728195e.png";